<script lang="ts">
    import Paragraph from '~/components/jet/info/Paragraph.svelte';
    import Credits from '~/components/jet/info/Credits.svelte';
    export let section;
</script>

<div class="info-section">
    {#if section?.itemKind === 'paragraph'}
        <Paragraph text={section.text} />
    {:else if section?.itemKind === 'credit'}
        <Credits infoItems={section.items} />
    {/if}
</div>

<style lang="scss">
    .info-section {
        --credits-list-padding: var(--bodyGutter);
        --credits-list-grid-cols: repeat(
            auto-fill,
            270px
        ); // Credits follow Grid B columns
        padding-bottom: 1rem;

        @media (--small) {
            --credits-list-grid-cols: repeat(2, 1fr);
        }

        @media (--medium) {
            --credits-list-grid-cols: repeat(3, 1fr);
        }

        @media (--large) {
            --credits-list-grid-cols: repeat(4, 1fr);
        }
    }
</style>
